import React, { useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";

function safeDecode(v) {
  try { return decodeURIComponent(v || ""); } catch { return v || ""; }
}

function sanitizeReturnPath(p, country) {
  if (!p) return `/${country}/`;

  // Αν έρθει full URL, κράτα μόνο path
  try {
    if (p.startsWith("http://") || p.startsWith("https://")) {
      const u = new URL(p);
      p = u.pathname + (u.search || "") + (u.hash || "");
    }
  } catch {}

  // must start with /
  if (!p.startsWith("/")) p = "/" + p;

  // Προστασία: μην επιτρέψεις να φύγει εκτός site
  if (p.startsWith("//")) return `/${country}/`;

  return p;
}

export default function ReturnFromInstacart() {
  const location = useLocation();
  const navigate = useNavigate();
  const params = useParams();
  const country = params.country || "el";

  useEffect(() => {
    const qs = new URLSearchParams(location.search);
    const raw = qs.get("return") || "";
    const decoded = safeDecode(raw);
    const target = sanitizeReturnPath(decoded, country);

    // replace για να μη μένει “επιστροφή” στο history
    navigate(target, { replace: true });
  }, [location.search, navigate, country]);

  return (
    <div style={{ padding: 24 }}>
      Επιστροφή από Instacart…
    </div>
  );
}
